import React from 'react';

import { UiTypography } from '@/components/ui/Typography';
import { OwnAiTitle } from '@/pages/Onboarding/Layouts/OwnAISecond/components/Title';
import { PaywallAppSteps } from '@/pages/Paywall/components/AppStep';

import { HowItWorksStyles } from './HowItWorks.styles';

export const SectionHowItWorks: React.FC = () => {
  return (
    <HowItWorksStyles>
      <OwnAiTitle className="how-it-works-title">
        How it{' '}
        <UiTypography variant="inherit" component="span" color="gradient">
          works
        </UiTypography>
      </OwnAiTitle>

      <PaywallAppSteps
        stepGetPlanBgUrl="https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/paywall/fast-pay-tab-man/app-in-phone.png"
        stepDiveInBgUrl="https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/paywall/fast-pay-tab-man/chat.png"
        stepExploreBgUrl="https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/paywall/fast-pay-tab-man/bots-set.png"
      />
    </HowItWorksStyles>
  );
};
